import { gql } from "@apollo/client";

export const GET_LEGAL_TERMS = gql`
  query GetLegalTerms {
    privacyPolicies: GetLegalTerms(term: "Política de Privacidade") {
      code
      name
      message
      id
      text
    }
    useTerms: GetLegalTerms(term: "Termo de Uso") {
      code
      name
      message
      id
      text
    }
  }
`;
